import React from "react"
import { graphql } from "gatsby"
import PropTypes from "prop-types"
import propTypes from "@styled-system/prop-types"
import styled from "styled-components"
import { color, opacity } from "styled-system"
import { shouldForwardProp } from "utils/styled-helpers.js"
import Img from "gatsby-image"

import VerticalText from "components/atoms/VerticalText"
import Box from "components/atoms/Box"

import Reveal from "components/utils/Reveal"
import Fade from "react-reveal/Fade"

const StyledSection = styled("section").withConfig({ shouldForwardProp })(color)

const BackgroundImage = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
  left: 0;
  top: 0;
  z-index: 0;
`

const SectionStyling = ({
  backgroundColor,
  accentImage,
  animateFrom,
  children,
  first,
  ...rest
}) => {
  const invertColor =
    backgroundColor === "mediumBlue" || backgroundColor === "darkBlue"
  rest.bg = `${backgroundColor}`

  const direction = animateFrom ? animateFrom : "right"

  return (
    <StyledSection
      style={{ position: "relative", overflowX: "hidden" }}
      backgroundColor
      {...rest}
    >
      {accentImage && (
        <BackgroundImage>
          <Fade
            left={animateFrom === "left"}
            right={animateFrom === "right"}
            top={animateFrom === "top"}
            bottom={animateFrom === "bottom"}
            distance="50px"
            duration={1500}
            fraction={0.75}
          >
            <Img fluid={accentImage.fluid} />
          </Fade>
        </BackgroundImage>
      )}
      <div style={{ position: "relative", zIndex: 10 }}>{children}</div>
      {first && <VerticalText invert={invertColor} />}
    </StyledSection>
  )
}

SectionStyling.defaultProps = {
  backgroundColor: "white",
}

SectionStyling.propTypes = {
  children: PropTypes.node.isRequired,
  ...propTypes.color,
}

export default SectionStyling

// removed backgroundimage from query

export const query = graphql`
  fragment SectionStyling on ContentfulSectionStyling {
    backgroundColor
    accentImage {
      fluid(quality: 90) {
        ...GatsbyContentfulFluid_withWebp
      }
    }
    animateFrom
  }
`
